/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Exchange200ResponseData
 */
export interface Exchange200ResponseData {
  /**
   *
   * @type {string}
   * @memberof Exchange200ResponseData
   */
  tokenType: string
  /**
   * Срок жизни access-токена в секундах
   * @type {number}
   * @memberof Exchange200ResponseData
   */
  expiresIn: number
  /**
   *
   * @type {string}
   * @memberof Exchange200ResponseData
   */
  accessToken: string
  /**
   *
   * @type {string}
   * @memberof Exchange200ResponseData
   */
  refreshToken: string
  /**
   * Пользователю требуется сменить сгенерированный пароль
   * @type {boolean}
   * @memberof Exchange200ResponseData
   */
  mustChangePassword: boolean
  /**
   * Телефон пользователя
   * @type {string}
   * @memberof Exchange200ResponseData
   */
  phone: string
}

/**
 * Check if a given object implements the Exchange200ResponseData interface.
 */
export function instanceOfExchange200ResponseData(
  value: object
): value is Exchange200ResponseData {
  if (!('tokenType' in value) || value['tokenType'] === undefined) return false
  if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false
  if (!('accessToken' in value) || value['accessToken'] === undefined)
    return false
  if (!('refreshToken' in value) || value['refreshToken'] === undefined)
    return false
  if (
    !('mustChangePassword' in value) ||
    value['mustChangePassword'] === undefined
  )
    return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  return true
}

export function Exchange200ResponseDataFromJSON(
  json: any
): Exchange200ResponseData {
  return Exchange200ResponseDataFromJSONTyped(json, false)
}

export function Exchange200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Exchange200ResponseData {
  if (json == null) {
    return json
  }
  return {
    tokenType: json['tokenType'],
    expiresIn: json['expiresIn'],
    accessToken: json['accessToken'],
    refreshToken: json['refreshToken'],
    mustChangePassword: json['mustChangePassword'],
    phone: json['phone'],
  }
}

export function Exchange200ResponseDataToJSON(
  value?: Exchange200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    tokenType: value['tokenType'],
    expiresIn: value['expiresIn'],
    accessToken: value['accessToken'],
    refreshToken: value['refreshToken'],
    mustChangePassword: value['mustChangePassword'],
    phone: value['phone'],
  }
}
